import React, { useState } from 'react';
import { HStack } from '@chakra-ui/react';
import { useColors } from '../../../../components/common/Color';
import HeaderSection from '../../../../components/common/Header/HeaderSection';
import CashTable from './CashTable';

function CashBook() {
  const colors = useColors();


  return (
    <div>
      {/* Use the new HeaderSection component */}
      <HeaderSection
        title="Cash Book" 
        breadcrumb={["Dashboard", "Accounts", "Cash Book"]} 
      />

      <HStack align="start" w='100%' gap="0" mt={4} p={6}>
        <CashTable colors={colors} />

      </HStack>
    </div>
  );
}

export default CashBook;
